<template>
    <div class="listingLinking">
        <div class="associated" v-infinite-scroll="leftLoad">
            <!--            <el-tabs style="width:560px" v-model="activeName1" @tab-click="handleClick1">-->
            <!--                <el-tab-pane label="房间" name="room"></el-tab-pane>-->
            <!--                <el-tab-pane label="房型" name="roomClass"></el-tab-pane>-->
            <div style="
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        padding-top: 10px;
                    ">
                <el-input size="small" v-model="leftParams.searchValue" placeholder="搜索"></el-input>
                <el-button style="margin-left: 20px" type="" size="small" @click="getLeftData(1)">搜索房源名称
                </el-button>
                <!--                    <el-button style="margin-left: 20px" type="" size="small">标签</el-button>-->
            </div>
            <!--                <div :class="cardIndex == item ? 'selectCard card' : 'card'" v-for="item in 3" :key="item"-->
            <!--                    @click="handlerCard(item)">-->
            <!--                    <div class="title">-->
            <!--                        XXXXXXXX房-->
            <!--                    </div>-->
            <!--                    <div class="cardItem" v-for="item2 in 3" :key="item2">-->
            <!--                        <img class="image" src="" alt="">-->
            <!--                        <div class="text">-->
            <!--                            <p style="word-wrap: break-word;">-->
            <!--                                XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX-->
            <!--                            </p>-->
            <!--                            <p style="margin-top: 10px;font-size: 16px;">18923907423</p>-->
            <!--                        </div>-->
            <!--                        <div style="text-align: center;"><el-button type="" size="small">解除关联</el-button></div>-->
            <!--                    </div>-->
            <!--                    <div v-if="item == cardIndex" class="cardBottomButton">-->
            <!--                        点击"关联"将此房源与房间关联-->
            <!--                    </div>-->
            <!--                </div>-->

            <div class="item">
                <div class="cardItem" v-for="item in leftData" :key="item.id">
                    <img class="image" :src="item.houseInfoSon.vCoverPic" alt="">
                    <div class="text">
                        <p style="word-wrap: break-word;">
                            {{ item.vHousTitle }}
                        </p>
                        <!--                            <p style="margin-top: 10px;font-size: 16px;">18923907423</p>-->
                    </div>
                    <div style="text-align: center;margin-left: 10px">
                        <el-button type="" size="small" @click="handlerDeleteLink(item)">解除关联</el-button>
                    </div>
                </div>
                <div v-if="leftLoading" style="width: 100%;height: 200px">
                    <div style="height: 100%;width: 100%" v-loading="leftLoading"></div>
                </div>
            </div>
            <!--            </el-tabs>-->
        </div>
        <div class="unassociated" v-infinite-scroll="rightLoad">
            <el-tabs style="" v-model="activeName2" @tab-click="handleClick2">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane label="美团" name="1"></el-tab-pane>
                <!--                <el-tab-pane label="小猪" name="2"></el-tab-pane>-->
                <!--                <el-tab-pane label="途家" name="3"></el-tab-pane>-->
                <div style="
                        display: flex;
                        justify-content: left;
                        align-items: center;
                    ">
                    <el-input size="small" v-model="rightParamData.roomTitle" placeholder="搜索"></el-input>
                    <el-button style="margin-left: 20px" type="" size="small" @click="getRightData(1)">搜索房源名称
                    </el-button>
                </div>
                <div class="item">
                    <div class="cardItem" v-for="item in rightData" :key="item.id">
                        <img class="image" :src="item.picture" alt="">
                        <div class="text">
                            <p style="word-wrap: break-word;">
                                {{ item.roomTitle }}
                            </p>
                            <p style="margin-top: 10px;font-size: 16px;">{{ item.username }}</p>
                        </div>
                        <div style="text-align: center;">
                            <el-button type="primary" style="margin-left: 10px" size="small" @click="handlerLink(item)">
                                关联
                            </el-button>
                        </div>
                    </div>
                    <div v-if="rightLoading" style="width: 100%;height: 200px">
                        <div style="height: 100%;width: 100%" v-loading="rightLoading"></div>
                    </div>
                </div>

            </el-tabs>
        </div>
    </div>
</template>

<script>
import {findByPage, hourselist, correlation, disassociate} from '@/api'

export default {
    name: "listingLinking",

    data() {
        return {
            activeName1: "room",
            activeName2: "all",
            inputValue2: "",
            cardIndex: 1,
            leftData: [],
            leftLoading: false,
            rightData: [],
            rightLoading: false,
            leftParams: {
                pageNum: 0,
                pageSize: 10,
                ['params[iHourseStatus]']: 10,
                searchValue: '',
                correlation: true,
            },
            rightParams: {
                pageNum: 0,
                pageSize: 10
            },
            rightParamData: {
                roomTitle: '',
                mt: false,
            },
            leftTotal: 1,
            rightTotal: 1
        };
    },

    mounted() {

    },
    methods: {
        getLeftData(pageNum = 1) {
            console.log(pageNum)
            this.leftLoading = true;
            this.leftParams.pageNum = pageNum;
            hourselist(this.leftParams).then(res => {
                if (res.data.code === 200) {
                    if (pageNum === 1) {
                        this.leftData = res.data.rows;
                    } else {
                        this.leftData.push(...res.data.rows);
                    }

                    this.leftTotal = res.data.total;
                    this.leftLoading = false;
                }
            })
        },
        getRightData(pageNum = 1) {
            this.rightLoading = true;
            this.rightParams.pageNum = pageNum;
            findByPage(this.rightParamData, this.rightParams).then(res => {
                console.log(res.data)
                if (res.data.code === 200) {
                    if (pageNum === 1) {
                        this.rightData = res.data.data.recode;
                    } else {
                        this.rightData.push(...res.data.data.recode);
                    }

                    this.rightTotal = res.data.data.total;
                    this.rightLoading = false;
                }

            })
        },
        handleClick1(tab, event) {
            console.log(tab, event);
        },
        handleClick2(tab, event) {
            console.log(tab, event);
        },
        handlerCard(index) {
            this.cardIndex = index
        },
        leftLoad() {

            console.log('leftLoad', this.leftTotal, this.leftData.length)
            if (this.leftLoading)
                return
            if (this.leftTotal > this.leftData.length) {
                this.leftParams.pageNum++;
                this.getLeftData(this.leftParams.pageNum);
            } else {
                // this.$message('已经到底了')
            }

        },
        rightLoad() {

            console.log('rightLoad', this.rightTotal, this.rightData.length)
            if (this.rightLoading)
                return
            if (this.rightTotal > this.rightData.length) {
                this.rightParams.pageNum++;
                this.getRightData(this.rightParams.pageNum);
            } else {
                // this.$message('已经到底了')
            }
        },
        handlerLink(item) {
            correlation(item).then(res => {
                if (res.data.code === 200) {
                    this.$message({type: "success", message: '关联成功'})
                    this.getRightData();
                    this.getLeftData();
                } else {
                    this.$message({type: "error", message: res.data.msg})
                }
            })
        },
        handlerDeleteLink(item) {
            disassociate({
                houseId: item.houseId
            }).then(res => {
                if (res.data.code === 200) {
                    this.$message({type: "success", message: '解除关联成功'})
                    this.getRightData();
                    this.getLeftData();
                } else {
                    this.$message({type: "error", message: res.data.msg})
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
body {
    margin: 0;
}

/deep/ .el-tabs__item {
    font-size: 16px;
    width: auto;
}

.listingLinking {
    height: 100%;
    width: 100%;
    background-color: #f7f8fa;
    display: flex;
    justify-content: left;

    .associated {
        width: 600px;
        border-radius: 10px;
        padding: 30px;
        background-color: white;
        overflow: auto;

        .selectCard {
            border: 2px solid #3786f1 !important;
        }

        .card {
            margin-top: 30px;
            width: 100%;
            padding: 20px;
            border: 1px solid #e2e5e9;
            border-radius: 10px;

            .title {
                font-size: 16px;
            }

            .cardItem {
                margin-top: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-bottom: 1px solid #e2e5e9;
                padding-bottom: 20px;

                .image {
                    width: 350px;
                    border-radius: 10px;
                }

                .text {
                    width: 70%;
                }
            }

            .cardBottomButton {
                margin-top: 15px;
                width: 100%;
                border: 1px dashed #3786f1;
                padding: 10px;
                font-size: 18px;
                text-align: center;
                color: #3786f1;
                border-radius: 10px;
            }
        }
    }

    .unassociated {
        width: 600px;
        border-radius: 10px;
        padding: 30px;
        margin-left: 30px;
        background-color: white;
        overflow: auto;

    }

    .item {
        .cardItem {
            margin-top: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #e2e5e9;
            padding-bottom: 20px;

            .image {
                width: 100px;
                border-radius: 10px;
                margin-right: 20px;
            }

            .text {
                width: 70%;
            }
        }
    }
}
</style>
